import { ACCESS_TOKEN_NAME, JSON_CONTENT_TYPE } from '../constant/constants';
import { IApiParams } from '../interface/IApiParams';
import { getApi } from './getApi';

export const apiPay = async (
  userId: string,
  purchaseId: string,
  payCena: number,
  email: string,
  isLending: number
) => {
  const params: IApiParams = {
    url: `api/createConstaructorPay.php?uid=${userId}&pid=${purchaseId}&price=${payCena}&email=${email}&isLending=${isLending}`,
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      'Access-Token': localStorage.getItem(ACCESS_TOKEN_NAME),
    },
  };
  return getApi(params, 'GET');
};
